import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty, Input, Modal, Button, Form, Radio, Select } from "antd";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../components/CustomWidgets/CustomPagination";
import arrowright from "../../assets/arrowright.svg";
import { useSelector } from "react-redux";
import Edit from "../../assets/Edit.svg";
import deleteicon from "../../assets/Order/Delete.svg";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";
import { toast } from "react-toastify";

const VatProductsTable = ({
  additionalData,
  pagination,
  vatTypes,
  upadateTable
  // onRowClick,
  // onDelete,
  // onEditLine,
}) => {
  const { t, i18n } = useTranslation();
  const [flag, setFlag] = useState(false);
  const navigate = useNavigate();
  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store,
  );

  // ✅ Modal editing states
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);
  const [taxName, setTax] = useState(null);
  const [taxType, setTaxType] = useState(null);
  const [form] = Form.useForm();
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const data = useMemo(() => additionalData || [], [additionalData]);

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setFlag(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);

  const handleEditClick = (row) => {
    setCurrentRow(row);
    setTax(row?.tax_id);
    setTaxType(row?.is_tax_price_inclusive == true ? "inclusive" : "exclusive");
    setIsModalVisible(true);
  };
  const handleSave = useCallback(async () => {
    try {
      const values = await form.validateFields();
      const updated = {
        ...currentRow,
        ...values,
      };
      // onSaveEdit?.(updated);
      setIsModalVisible(false);
      setCurrentRow(null);
    } catch (error) {
      console.error("Validation failed:", error);
    }
  }, [form, currentRow]);

  const handleCancel = () => {
    setIsModalVisible(false);
    setCurrentRow(null);
  };


  const columns = useMemo(() => {
    return [
      {
        Header: t("Product Name"),
        accessor: "product_name",
        width: "30%",
        Cell: ({ row }) => (
          <div className="text-start">{row.original?.product_name2 && row.original?.product_name2 != '' ? row.original?.product_name2 : row.original?.product_name}</div>
        ),
      },
      // {
      //   Header: t("Product Custom Name"),
      //   accessor: "product_name2",
      //   width: "30%",
      //   Cell: ({ row }) => (
      //     <div className="text-start">{row.original?.product_name2 || "-"}</div>
      //   ),
      // },
      {
        Header: t("Tax Name"),
        accessor: "tax_name",
        width: "20%",
        Cell: ({ row }) => (
          <div className="text-start">{row.original?.tax_name}</div>
        ),
      },
      {
        Header: t("Tax Type"),
        accessor: "is_tax_price_inclusive",
        width: "20%",
        Cell: ({ row }) => (
          <div className="text-start">
            {row.original?.is_tax_price_inclusive == true
              ? t("Inclusive")
              : t("Exclusive")}
          </div>
        ),
      },
      {
        Header: t("Actions"),
        accessor: "actions",
        width: "15%",
        Cell: ({ row }) => (
          <div className="flex gap-2 justify-start">
            <img
              src={Edit}
              className="cursor-pointer h-4 w-4"
              alt="Edit"
              onClick={(e) => {
                e.stopPropagation();
                handleEditClick(row.original);
              }}
            />
            <img
              src={deleteicon}
              className="cursor-pointer h-4 w-4 mx-2"
              alt="Delete"
              onClick={(e) => {
                e.stopPropagation();
                DeleteProductTax(row.original);
              }}
            />
          </div>
        ),
      },
    ];
  }, [t, i18n.language,upadateTable]);

  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect,
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);

  const UpdateProductTax = async () => {
    console.log("currentRow==>", currentRow);

    const payload = {
      retailer_id: company_id,
      record_id: currentRow?.id, // id from the GetProductTaxes
      is_delete: false,
      tax_id:taxName,
      is_tax_price_inclusive: taxType == "exclusive" ? false : true,
      is_active: true,
    };
    try {
      const res = await axiosInstance.post(URLS.UPDATE_PRODUCT_TAX, payload);
      const res1 = res?.data;

      // console.log("res1---->", res1);

      if (res1?.result?.status_code === 200) {
        setIsModalVisible(false);
        toast.success(t(res1?.result?.status));
        upadateTable()
      } else {
        toast.error(t(res1?.result?.status));
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      //   setloading(false);
    } finally {
      //   setloading(false);
    }
  };

  const DeleteProductTax = async (row) => {

    const payload = {
      retailer_id: company_id,
      record_id: row?.id, // id from the GetProductTaxes
      is_delete: true,
    };
    try {
      const res = await axiosInstance.post(URLS.UPDATE_PRODUCT_TAX, payload);
      const res1 = res?.data;
      if (res1?.result?.status_code === 200) {
        setIsModalVisible(false);
        toast.success(t(res1?.result?.status));
        upadateTable()
      } else {
        toast.error(t(res1?.result?.status));
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
    } finally {
    }
  };
  

  return (
    <div
      className="container flex flex-col mx-auto mt-4"
      style={{ maxWidth: "100%" }}
    >
      {additionalData?.length === 0 && !flag ? (
        <div className="h-screen w-[90%] mt-2 ">
          <ShimmerLoader />
        </div>
      ) : (
        <>
          {/* Header */}
          <table
            className="font-normal max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
            style={{ tableLayout: "fixed" }}
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr
                  key={headerGroup.id}
                  {...headerGroup.getHeaderGroupProps()}
                  className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                >
                  {headerGroup.headers.map((column) => (
                    <th
                      key={column.id}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      className="py-3 whitespace-nowrap"
                      style={{ width: column.width }}
                    >
                      <div className="flex items-start ms-2 text-sm ">
                        {column.render("Header")}
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <img
                              src={Vectorsorting}
                              style={{ minHeight: 10, minWidth: 10 }}
                              alt="vector"
                            />
                          ) : (
                            <img
                              className="rotate-180"
                              src={Vectorsorting}
                              alt="vector"
                            />
                          )
                        ) : (
                          ""
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
          </table>

          {/* Body */}
          <div
            className="scrollbar-none bg-[#F7F9FD]"
            style={{ overflowY: "auto", maxHeight: "600px" }}
          >
            <table
              className="font-normal max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
              style={{ tableLayout: "fixed" }}
            >
              <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr
                      key={row.id}
                      {...row.getRowProps()}
                      className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                    >
                      {row.cells.map((cell, index) => (
                        <td
                          key={index}
                          {...cell.getCellProps()}
                          className={`p-2 text-[#272728] h-1212 text-sm font-normal ${
                            index < row.cells.length - 1 ? "relative" : ""
                          }`}
                          style={{ width: cell.column.width }}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })}
                {page.length === 0 && (
                  <tr>
                    <td colSpan={"100%"}>
                      <Empty
                        className="mt-10"
                        description={t("No data available")}
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="">
            <CustomPagination
              data={data?.length}
              pageIndex={pageIndex}
              pageCount={page?.length}
              canPreviousPage={pageIndex != 1 ? true : false}
              canNextPage={data?.length == pageSize ? true : false}
              gotoPage={(page) => {
                nextPage(page);
              }}
              previousPage={() => {
                setpageIndex(pageIndex - 1);
              }}
              nextPage={() => {
                setpageIndex(pageIndex + 1);
              }}
              pageSize={pageSize}
              setPageSize={(pageSize) => {
                setPageSize(pageSize);
              }}
            />
          </div>
        </>
      )}

      {/* ✅ Edit Modal */}
      <Modal
        title={
          <span className="text-lg font-semibold">{t("Edit Product Tax")}</span>
        }
        open={isModalVisible}
        onOk={UpdateProductTax}
        onCancel={handleCancel}
        okText={t("Save")}
        cancelText={t("Cancel")}
        centered
        className="edit-group-modal"
        okButtonProps={{
          className:
            "font-semibold bg-primaryBlue hover:bg-primaryBlue text-white text-sm px-6 py-5 rounded-md",
          // style: { backgroundColor: "primaryBlue", borderColor: "primaryBlue" }
        }}
        cancelButtonProps={{
          className: "font-semibold text-sm px-6 py-5 rounded-md",
        }}
      >
        <div className="mb-3">
          <h3 className="text-sm font-semibold mb-2 text-gray-600">
            {t("Tax")}
          </h3>
          <Select
            style={{ width: "100%" }}
            placeholder={t("Select Tax")}
            className="h-10"
            value={taxName}
            onChange={(value) => setTax(value)}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
            options={vatTypes.map((vat) => ({
              label: `${vat.tax_name} (${vat.tax_rate_percent}%)`,
              value: vat.id,
            }))}
          />
        </div>
        <div className="mb-3">
          <h3 className="text-sm font-semibold mb-2 text-gray-600">
            {t("Tax Type")}
          </h3>

          <Radio.Group
            value={taxType}
            onChange={(e) => setTaxType(e.target.value)}
          >
            <Radio value="exclusive">{t("Exclusive")}</Radio>
            <Radio value="inclusive">{t("Inclusive")}</Radio>
          </Radio.Group>
        </div>
      </Modal>
    </div>
  );
};

export default VatProductsTable;
